module.exports = "/images/logout.svg?d9180ad0deeedd18295e93163fff40d5";